import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/routes";
import { AuthProvider } from "./contexts/AuthContext";
import PopUp from "../src/view/components/PopUp/PopUp"

function App() {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
        {/* <PopUp isOpen={isModalOpen} closeModal={closeModal}/> */}
      </AuthProvider>
    </Router>
  );
}

export default App;
